<div class="dialog-box">
  <div class="dialog-box__header">
    <button mat-icon-button (click)="cancel()" tabindex="-1">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="dialog-box__content confirmation-content">
    <h1>{{ titleKey | translate }}</h1>
    <p>{{ data.question | translate }}</p>
    <div class="confirmation-actions" [class.confirmation-actions--triple]="hasSecondaryAction">
      @if (hasSecondaryAction) {
        <div class="confirmation-actions__row confirmation-actions__row--main">
          <button class="btn btn--secondary btn--longer" (click)="cancel()">{{ cancelLabelKey | translate }}</button>
          <button class="btn btn--primary btn--longer" (click)="confirm()">{{ confirmLabelKey | translate }}</button>
        </div>

        <div class="confirmation-actions__row confirmation-actions__row--secondary">
          <button class="btn btn--secondary btn--longer confirmation-actions__long-btn" (click)="secondaryAction()">
            {{ data.secondaryActionLabel | translate }}
          </button>
        </div>
      } @else {
        <button class="btn btn--secondary btn--longer" (click)="cancel()">{{ cancelLabelKey | translate }}</button>
        <button class="btn btn--primary btn--longer" (click)="confirm()">{{ confirmLabelKey | translate }}</button>
      }
    </div>
  </div>
</div>
